import { SVButton } from '@/components/core';
import { MESSAGES } from '@/constants/messages';
import { UseMutateAsyncFunction } from '@tanstack/react-query';
import showToast from '@/utils/toast';
import { Stack } from '@mui/material';

type UnlockTeammateFormProps = {
  teammateFullName: string;
  unlockTeammate: UseMutateAsyncFunction<unknown, Error, void, unknown>;
  isUnlockTeammatePending: boolean;
  onSuccess: () => void;
  onCancel: () => void;
};

export default function UnlockTeammateForm({
  teammateFullName,
  unlockTeammate,
  isUnlockTeammatePending,
  onSuccess,
  onCancel,
}: UnlockTeammateFormProps) {
  const handleSubmit = async () => {
    try {
      await unlockTeammate();
      showToast({
        type: 'success',
        data: {
          content:
            'Teammate ' + teammateFullName + ' has been successfully unlocked.',
        },
      });
      onSuccess();
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  };

  return (
    <Stack spacing={2} direction="row" justifyContent="flex-end" mt={4}>
      <SVButton onClick={onCancel} variant="tertiary">
        No, Cancel
      </SVButton>
      <SVButton
        isLoading={isUnlockTeammatePending}
        variant="success"
        onClick={handleSubmit}>
        Yes, Unlock Teammate
      </SVButton>
    </Stack>
  );
}
